import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { catchError, forkJoin, throwError } from 'rxjs';
import { UserService } from './core/user/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from './core/auth/auth.service';

export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const userService = inject(UserService);

    const auth = inject(AuthService)
    const router = inject(Router)

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        messagesService.getAll(),
        notificationsService.getAll(),
        quickChatService.getChats(),
        shortcutsService.getAll(),


        navigationService.get(),
        userService.get()
    ]).pipe(catchError(error => {
        if (error instanceof HttpErrorResponse) {
            if (error.status === 403) { //forbidden
                auth.signOut()
                console.log("redirecting to login again")
                router.navigate(['/'])
            }
        }
        return throwError(() => error)
    }))
};
